module.exports = __webpack_public_path__ + "static/media/pencil.770ea369.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pencil.svg
// module id = 844
// module chunks = 0